import { render, staticRenderFns } from "./DynamicNotifications.vue?vue&type=template&id=052a1557&"
import script from "./DynamicNotifications.vue?vue&type=script&lang=js&"
export * from "./DynamicNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports